export default "__VITE_ASSET__046d51cf__"